module.exports = require('currency.js')
